type CookieConsentStatus = {
	analytics: boolean;
	profiling: boolean;
};

declare global {
	interface Window {
		OnetrustActiveGroups?: string;
	}
}

function getOneTrustConsentData(): CookieConsentStatus | undefined {
	if (
		typeof window !== 'undefined' &&
		window?.OnetrustActiveGroups &&
		typeof window?.OnetrustActiveGroups === 'string'
	) {
		return {
			analytics: window.OnetrustActiveGroups.includes('C0002'),
			profiling: window.OnetrustActiveGroups.includes('C0004'),
		};
	}

	return undefined;
}

export default getOneTrustConsentData;
